import styled from '@emotion/styled'

import { Typo30WhiteNBI } from '../../../themes/Fonts/Nort'
import {
  minDeviceWidth,
  mobile,
  customDevice,
  maxDeviceWidth
} from '../../../utils/mixins'
import Colors from '../../../themes/Colors'

import CloudinaryS3LazyLoadedImage from '../../CloudinaryS3LazyLoadedImage'

export const Heading = styled(Typo30WhiteNBI)`
  line-height: 1.5;
  letter-spacing: 1px;
  display: block;
  margin-bottom: 6px;

  ${maxDeviceWidth(767)} {
    font-size: 20px;
    margin-bottom: 5px;
  }
`

export const Underline = styled.div`
  width: 100px;
  height: 2px;
  background-color: ${Colors.pumpkinOrange};

  ${maxDeviceWidth(767)} {
    width: 55px;
  }
`

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  padding-top: 40px;
  padding-bottom: 40px;
  background-color: ${Colors.darkTwoDefault};
  align-items: center;

  ${minDeviceWidth(768)} {
    padding-top: 60px;
    padding-bottom: 60px;
  }
`

export const EligibilityImage = styled(CloudinaryS3LazyLoadedImage)`
  width: 330px;
  height: auto;
  margin-left: auto;
  margin-right: auto;
`

export const ResponsiveContainer = styled.div`
  width: 1124px;
  margin: auto;

  ${mobile} {
    width: 88.8%;
  }

  ${customDevice(768, 959)} {
    width: 90%;
  }

  ${customDevice(960, 1200)} {
    width: 90%;
  }
`
export const HeadingWrapper = styled.div`
  margin-bottom: 40px;
`

export const ButtonWrapper = styled.div`
  margin-top: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
`
export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`



// WEBPACK FOOTER //
// ./src/components/ExperimentalMarketing/PlacesToPlayIbcricket/styledComponents.js